import React, { useState, useEffect } from "react"

import { AccordionTab } from "./utils"

export const Accordion = ({ tabs, is_inverted, preselection = 0 }) => {
  const [selectedTab, setSelectedTab] = useState(preselection)

  useEffect(() => {
    setSelectedTab(preselection)
  }, [preselection])

  return (
    <React.Fragment>
      {tabs?.map(({ title, content }, index) => (
        <AccordionTab
          key={title}
          {...{
            title,
            content,
            index,
            selectedTab,
            setSelectedTab,
            is_inverted,
            last_tab: index === tabs?.length - 1,
          }}
        />
      ))}
    </React.Fragment>
  )
}
